<form [formGroup]="filterFormGroup">
  <div class="flex-grow">
    <div class="filter-elements">

      <!-- Name -->
      <mat-form-field redispatchProvideReadonly>
        <mat-label>Name</mat-label>
        <input matInput
          name="name"
          [matAutocomplete]="name"
          data-qa="filter-name"
          formControlName="name">
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

        <mat-autocomplete #name="matAutocomplete"
          panelWidth="200">
          @for (name of filteredName$ | async; track name) {
            <mat-option [value]="name"  data-qa="filter-name-option">
              {{name}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <!-- Teilgebiet -->
      <mat-form-field redispatchProvideReadonly>
        <mat-label>Teilgebiet</mat-label>
        <input matInput
          name="teilgebiet"
          [matAutocomplete]="teilgebiet"
          data-qa="filter-teilgebiet"
          formControlName="teilgebiet">
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

        <mat-autocomplete #teilgebiet="matAutocomplete"
          panelWidth="200">
          @for (teilgebiet of filteredTeilgebiete$ | async; track teilgebiet) {
            <mat-option [value]="teilgebiet"  data-qa="filter-teilgebiet-option">
              {{teilgebiet}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <!-- Netzbetreibernummer -->
      <mat-form-field redispatchProvideReadonly>
        <mat-label>Netzbetreibernummer</mat-label>
        <input matInput
          name="netzbetreibernummer"
          [matAutocomplete]="netzbetreibernummer"
          data-qa="filter-netzbetreibernummer"
          formControlName="netzbetreibernummer">
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

        <mat-autocomplete #netzbetreibernummer="matAutocomplete"
          panelWidth="200">
          @for (netzbetreibernummer of filteredNetzbetreibernummer$ | async; track netzbetreibernummer) {
            <mat-option [value]="netzbetreibernummer"  data-qa="filter-netzbetreibernummer-option">
              {{netzbetreibernummer}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <!-- Stadtwerke-ID -->
      <mat-form-field redispatchProvideReadonly>
        <mat-label>Stadtwerke-ID</mat-label>
        <input matInput
          name="stadtwerkeId"
          [matAutocomplete]="stadtwerkeId"
          data-qa="filter-stadtwerkeId"
          formControlName="stwId">
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

        <mat-autocomplete #stadtwerkeId="matAutocomplete"
          panelWidth="200">
          @for (stadtwerkeId of filteredStadtwerkeId$ | async; track stadtwerkeId) {
            <mat-option [value]="stadtwerkeId"  data-qa="filter-stadtwerkeId-option">
              {{stadtwerkeId}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <!-- Geschäftspartner-ID -->
      <mat-form-field redispatchProvideReadonly>
        <mat-label>Geschäftspartner-ID</mat-label>
        <input matInput
          name="geschaeftspartnerId"
          [matAutocomplete]="geschaeftspartnerId"
          data-qa="filter-geschaeftspartnerId"
          formControlName="geschaeftspartnerId">
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

        <mat-autocomplete #geschaeftspartnerId="matAutocomplete"
          panelWidth="200">
          @for (geschaeftspartnerId of filteredGeschaeftspartnerId$ | async; track geschaeftspartnerId) {
            <mat-option [value]="geschaeftspartnerId"  data-qa="filter-geschaeftspartnerId-option">
              {{geschaeftspartnerId}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <!-- Date -->
      <mat-form-field redispatchProvideReadonly data-qa="filter-lastImportDate">
        <mat-label>Letzte Aktualisierung (Erzeugerdaten)</mat-label>
        <mat-date-range-input formGroupName="lastImportDate" [rangePicker]="picker">
          <input matStartDate formControlName="start" placeholder="Start date">
          <input matEndDate formControlName="end" placeholder="End date">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker">
          <mat-icon matDatepickerToggleIcon svgIcon="innogy_picto_calendar-date-year"></mat-icon>
        </mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
      </mat-form-field>

      <!-- Dienstleistungsart -->
      <mat-form-field redispatchProvideReadonly>
        <mat-label>Dienstleistungsart</mat-label>
        <input matInput
          name="dienstleistungsart"
          [matAutocomplete]="dienstleistungsart"
          data-qa="filter-dienstleistungsart"
          formControlName="dienstleistungsart">
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

        <mat-autocomplete #dienstleistungsart="matAutocomplete" panelWidth="200">
          @for (dienstleistungsart of filteredDienstleistungsart$ | async; track dienstleistungsart) {
            <mat-option [value]="dienstleistungsart"  data-qa="filter-dienstleistungsart-option">
              {{dienstleistungsart}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <!-- Dienstleistungsmodul -->
      <mat-form-field redispatchProvideReadonly>
        <mat-label>Dienstleistungsmodule</mat-label>
        <mat-select
          formControlName="dienstleistungsmoduleBeschreibung"
          data-qa="filter-dienstleistungsmodule"
          multiple>
          @for (modul  of allDienstleistungsmodul$ | async; track modul ) {
            <mat-option [value]="modul">{{modul}}</mat-option>
          }
        </mat-select>
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
      </mat-form-field>
    </div>
  </div>

  <div class="reset-button-container">
    <button id="resetFiltersButton" matButton="filled" type="reset" data-qa="reset-filter-button">
        <mat-icon>autorenew</mat-icon>
        Zurücksetzen
    </button>
    <button id="exportCsvButton" matButton="outlined" data-qa="export-csv-button"
      (click)="exportNetzbetreiber()">
        <mat-icon>file_download</mat-icon>
        CSV exportieren
    </button>
  </div>
</form>

